import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=79d86cae&"
import script from "./Settings.vue?vue&type=script&lang=ts&"
export * from "./Settings.vue?vue&type=script&lang=ts&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=79d86cae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports